export enum BulletListSeparator {
  DOT = "DOT",
  PIPE = "PIPE"
}
